import { useCallback, useEffect, useState } from 'react';

import useSocket from '@/hooks/useSocket';
import { socketsEntities } from '@/constants/navigationPaths';

type GlobalViewSocketData = {
  id?: string;
  genTotalMW?: number;
};

type GlobalViewSocketResponse = {
  _meta?: { sentAt?: string };
  data?: GlobalViewSocketData;
};

export type GenTotalSocketUpdate = {
  genTotalMW: number;
  sentAt: string;
};

export const useLocationGenTotalSocket = (siteId: string) => {
  const [genTotalSocketUpdate, setGenTotalSocketUpdate] =
    useState<GenTotalSocketUpdate | null>(null);

  const onLastWsMessage = useCallback(
    (socketResponse: GlobalViewSocketResponse) => {
      const payload = socketResponse?.data;

      if (!payload || payload.id !== siteId) return;
      if (payload.genTotalMW == null) return;

      setGenTotalSocketUpdate({
        genTotalMW: payload.genTotalMW,
        sentAt: socketResponse?._meta?.sentAt ?? new Date().toISOString()
      });
    },
    [siteId]
  );

  const { readyState } = useSocket({
    connectWs: Boolean(siteId),
    entityName: socketsEntities.globalView,
    entityId: '*',
    onLastWsMessage
  });

  useEffect(() => {
    setGenTotalSocketUpdate(null);
  }, [siteId]);

  return {
    genTotalMWFromSocket: genTotalSocketUpdate?.genTotalMW ?? null,
    genTotalSocketUpdate,
    readyState
  };
};
